module.exports = __webpack_public_path__ + "img/huizhang.bebb14de.png";